import { cloneDeep } from 'lodash-es';
import * as Sentry from '@sentry/browser';
import type { Site } from '@hotjar/site';
import type { Segment } from '@hotjar/webapp/features/Recordings/types';
import { DEFAULT_SEGMENT } from '@hotjar/webapp/domains/segments/constant';
import { getAllCachedSegments, getAllSegments } from '@hotjar/webapp/domains/segments/service';

export const fetchSegments = async (site: Site): Promise<Segment[]> => {
  try {
    return getAllSegments(site.id, site);
  } catch (e) {
    Sentry.captureException(e, {
      contexts: {
        section: { name: 'Fetching segments' },
      },
    });

    window.dispatchEvent(
      new CustomEvent('hjNotification', {
        detail: {
          cls: 'notification-box-error',
          message: 'Error fetching segments',
          timeout: 6000,
        },
      }),
    );

    // If the api call fails, we should still return the default segment to avoid breaking the full page
    return cloneDeep([DEFAULT_SEGMENT]);
  }
};

export const getCachedSegments = (site: Site): Segment[] | void =>
  getAllCachedSegments(site.id, site);
